/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Faq_A9Inputs */

const en_home_faq_a9 = /** @type {(inputs: Home_Faq_A9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CADCraft is written entirely in Rust. It renders on the GPU through wgpu, which uses WebGPU or WebGL2 in the browser and native graphics APIs on the desktop.`)
};

/**
* | output |
* | --- |
* | "CADCraft is written entirely in Rust. It renders on the GPU through wgpu, which uses WebGPU or WebGL2 in the browser and native graphics APIs on the desktop." |
*
* @param {Home_Faq_A9Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const home_faq_a9 = /** @type {((inputs?: Home_Faq_A9Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Faq_A9Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_faq_a9(inputs)
});
export { home_faq_a9 as "home.faq.a9" }